import { AppThunk } from '../../../../../../store/types';
import { getActiveUserGroup } from '../../../../../../store/models/selectors';
import { Navigator } from '../../../../../../effects/navigator';

export class PhraseDetailsTabTranslationNativeLangEvents {

  public static onOpenGroup(): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      const group = getActiveUserGroup(getState());
      if (group) {
        Navigator.openMyStuff(group.id);
      }
    }
  }

}
